var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _c(
        "form",
        { attrs: { "data-vv-scope": "comment-management" } },
        [
          _c("vs-textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true, min: 5 },
                expression: "{required: true, min: 5}"
              }
            ],
            staticClass: "mb-0",
            attrs: { maxlength: "255", label: "Comentario", name: "comment" },
            model: {
              value: _vm.comment,
              callback: function($$v) {
                _vm.comment = $$v
              },
              expression: "comment"
            }
          }),
          _vm.errors.first("comment-management.comment")
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger\n       vs-input--text-validation-span v-enter-to",
                  staticStyle: { height: "20px" }
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.errors.first("comment-management.comment")) +
                        " "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 text-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2 mt-3",
                  attrs: {
                    "data-cy": "process-massive-button",
                    variant: "primary",
                    size: "sm"
                  },
                  on: { click: _vm.sendAction }
                },
                [_vm._v(" Confirmar " + _vm._s(_vm.action) + " ")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }